// extracted by mini-css-extract-plugin
export default {"popover":"ClosablePopover_popover__JfyTc"};